import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";

import { getAllUnReadNotifications } from "../../../helpers/UAM/notificaiton.helper";


//i18n
import { withTranslation } from "react-i18next";
import moment from "moment";

const NotificationDropdown = props => {
  const [menu, setMenu] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const shouldRenderButton = false;
  const shouldRenderButton2 = true
  let { roleName } = JSON.parse(localStorage.getItem("user"))
  if (roleName == 'dealer') {
    roleName = 'customer'
  }
  const formatDateTime = (dateTimeString) => {
    const date = moment(dateTimeString).format("DD MMM, YYYY");
    const time = moment(dateTimeString).format("hh:mm A");
    return `${date} at ${time}`
  };

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("user"))
    getAllUnReadNotifications({ userId: user.id, limit: 5 })
      .then((response) => {
        setNotifications(response.data.data)
        setNotificationCount(response.data.totalItems)
      })
      .catch((error) => {

      });

  }, []);


  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
        direction="up"
      >
        <DropdownToggle
          className="btn header-item noti-icon position-relative font-size-12"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <span>
            <i className="bx bx-bell bx-tada" style={{ fontSize: '25px' }} />
          </span>
          <span className="badge bg-danger rounded-pill">{showCount(notificationCount)}</span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg  p-0 notification_container"
          style={{ width: "350px" }}
        >
          <div className="p-3 pb-2 border-bottom border-2 border-body">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0 fw-bolder"> {props.t("Notifications")} </h6>
              </Col>
              <div className="col-auto">
                <Link to={`/${roleName}/notifications`} className="small fw-bold"
                  onClick={() => setMenu(!menu)}
                >
                  {" "}
                  View All <span className="fs-4 fw-bolder">&rarr;</span>
                </Link>
              </div>
            </Row>
          </div>
          {shouldRenderButton2 && (
            <SimpleBar style={{ height: "230px", paddingRight: "6px" }}>
              {notifications.map((item) => (
                <Link key={item.id} to={`/${roleName}/notifications`} className="text-reset notification-item"
                  onClick={() => setMenu(!menu)}
                >
                  <div className="d-flex border-bottom border-1 border-body">
                    <div className="flex-grow-1">
                      <h6 className="mt-0 mb-1">{item.notificationHeader}</h6>
                      <div className="font-size-12 text-muted">
                        <p className="mb-0">
                          <i className="mdi mdi-clock-outline" /> {formatDateTime(item.createdAt)}
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </SimpleBar>
          )}
          {shouldRenderButton && (
            <SimpleBar style={{ height: "230px" }}>
              <Link to="" className="text-reset notification-item">
                <div className="d-flex">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title bg-primary rounded-circle font-size-16">
                      <i className="bx bx-cart" />
                    </span>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">
                      {props.t("The order is placed")}
                    </h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">
                        {props.t(
                          "The order is placed for JEMSTER by Raghuvansh Agrofarms Ltd"
                        )}
                      </p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline" />{" "}
                        {props.t("1 hr ago")}{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="" className="text-reset notification-item">
                <div className="d-flex">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title bg-success rounded-circle font-size-16">
                      <i className="bx bxs-truck" />
                    </span>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">
                      {props.t("The item is shipped")}
                    </h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">
                        {props.t(
                          "The order for Rath Rasayan Limited is shipped"
                        )}
                      </p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline" />{" "}
                        {props.t("3 min ago")}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
              <Link to="" className="text-reset notification-item">
                <div className="d-flex">
                  <div className="avatar-xs me-3">
                    <span className="avatar-title bg-success rounded-circle font-size-16">
                      <i className="bx bx-box" />
                    </span>
                  </div>
                  <div className="flex-grow-1">
                    <h6 className="mt-0 mb-1">
                      {props.t("The item is delivered")}
                    </h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">
                        {props.t(
                          "The order for Raghuvansh Agrofarms Ltd is delivered"
                        )}
                      </p>
                      <p className="mb-0">
                        <i className="mdi mdi-clock-outline" />{" "}
                        {props.t("3 min ago")}
                      </p>
                    </div>
                  </div>
                </div>
              </Link>
            </SimpleBar>
          )}

        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withTranslation()(NotificationDropdown);

NotificationDropdown.propTypes = {
  t: PropTypes.any
};

function showCount(count) {
  if (count > 9) {
    return '9+'
  }
  return count
}